import { SchoolService, BaseService } from "@/services/school.service";

const HealthService = {
    getWorkouts() {
        return SchoolService.getAll("health/workouts")
    },

    getMeasurements(workoutId, dayaType) {
        return SchoolService.getAll("health/workouts/" + workoutId + "/measurements?types=" + dayaType)
    },

    addMeasure(payload) {
    	return SchoolService.create("health-measurements", payload)
    },

    updateMeasure(object) {
        return SchoolService.update("health-measurements", object.identifier, object)
    },

    deleteMeasure(object) {
        return SchoolService.delete("health-measurements", object.identifier, null)
    },
     
}

export { HealthService };
